import components from "../components";

export default (editor, opts = {}) => {
    const COMPS = editor.DomComponents;
    const TYPE = COMPS.getType('container');
    const MODEL = TYPE.model;
    const VIEW = TYPE.view;
    const BM = editor.BlockManager;

    const CONFIRMATION_TYPE_1 = "email";
    const CONFIRMATION_TYPE_2 = "phone";
    const CONFIRMATION_TYPE_3 = "password";

    COMPS.addType('C-CONTAINER-COREGISTRO', {
        model: MODEL.extend({
            defaults: {
                ...MODEL.prototype.defaults,
                name: "C-CONTAINER-COREGISTRO",
                "custom-name": "C-CONTAINER-COREGISTRO",
                attributes: {
                    "data-slg-type": "C-CONTAINER-COREGISTRO",
                    "data-slg-confirmation-type": "",
                    "data-slg-required-acceptance": "false",
                },
                classes: ['container-fluid'],
                style: {
                    display: "none"
                },
            },
            onRender() {

            },
            getConfirmationType() {
                let component = this;
                let attributes = component.get('attributes');
                return attributes['data-slg-confirmation-type'];
            },
            getRequiredAcceptance() {
                let component = this;
                let attributes = component.get('attributes');
                return attributes['data-slg-required-acceptance'];
            },
            hasComponentCoregistro() {
                let component = this;
                return (component.components().length > 0) ? true : false;
            },
            getComponentCoregistro() {
                let component = this;
                return component.components().at(0);
            },
            getComponentAcceptanceTerms() {
                let component = this;
                return (component.components().at(1)) ? component.components().at(1) : undefined;
            },
            getAcceptanceTermsURL() {
                let component = this;
                console.log(component.components());
                console.log(component.components().at(1).findType('link'));
                let component_acceptance_terms = component.components().at(1);
                let component_link = component_acceptance_terms.findType('link')[0];
                let url = "#"
                url = component_link.get('attributes')['href'];
                console.log(url);
                return url;
            },
            hasComponentAcceptanceTerms() {
                let component = this;
                let find = component.findType("C-ACCEPTANCE-TERMS");
                return (find.length > 0) ? true : false;
            },

        }, {
            isComponent(el) {
                if (el && el.getAttribute && el.getAttribute('data-slg-type') == "C-CONTAINER-COREGISTRO")
                    return { type: 'C-CONTAINER-COREGISTRO' }
            },
        }),
        view: VIEW.extend({
            init() {
                let component = this.model;
                // this.listenTo(component, 'change:attributes:data-slg-confirmation-type', this.renderComponentConfirmationType);
                // this.listenTo(component, 'change:attributes:data-slg-required-acceptance', this.renderComponentAcceptanceTerms);

            },
            onRender() {
                let component = this.model;
                this.show();
                this.renderComponentConfirmationType(component);
                this.renderComponentAcceptanceTerms(component);

            },
            show() {
                this.el.style.display = "block";
            },
            hide() {
                this.el.style.display = "none";
            },
            toggle() {
                if (this.el.style.display == 'none' || this.el.style.display == "") {
                    this.show();
                } else {
                    this.hide();
                }
            },
            renderComponentConfirmationType(component) {
                // console.log("Render confirmation type!!");
                this.show();
                let confirmation_type = component.getConfirmationType();
                let component_coregistro = {};
                switch (confirmation_type) {
                    case CONFIRMATION_TYPE_1:
                        component_coregistro = {
                            name: "C-CONFIRMATION-TYPE",
                            tagName: "div",
                            droppable: false,
                            draggable: false,
                            removable: false,
                            copyable: false,
                            classes: ["mt-3", 'form-group'],
                            components: [
                                {
                                    type: 'label',
                                    droppable: false,
                                    draggable: false,
                                    removable: false,
                                    copyable: false,
                                    content: "Email:",
                                },
                                {
                                    type: 'input',
                                    attributes: {
                                        type: "email",
                                        name: "email",
                                        placeholder: "Email",
                                        required: true
                                    },
                                    classes: ['form-control']
                                }
                            ]

                        }
                        break;
                    case CONFIRMATION_TYPE_2:
                        component_coregistro = {
                            name: "C-CONFIRMATION-TYPE",
                            tagName: "div",
                            classes: ["mt-3", 'form-group'],
                            components: [
                                {
                                    type: 'label',
                                    components: [
                                        {
                                            type: 'text',
                                            content: "Phone:"
                                        }
                                    ]
                                },
                                {
                                    type: 'input',
                                    attributes: {
                                        type: "tel",
                                        name: "phone",
                                        placeholder: "Phone",
                                        required: true
                                    },
                                    classes: ['form-control']
                                }
                            ]

                        }
                        break;
                    case CONFIRMATION_TYPE_3:
                        component_coregistro = {
                            name: "C-CONFIRMATION-TYPE",
                            tagName: "div",
                            classes: ["mt-3", 'form-group'],
                            components: [
                                {
                                    type: 'label',
                                    components: [
                                        {
                                            type: 'text',
                                            content: "Password:"
                                        }
                                    ]
                                },
                                {
                                    type: 'input',
                                    attributes: {
                                        type: "password",
                                        name: "password",
                                        placeholder: "password",
                                        required: true
                                    },
                                    classes: ['form-control']
                                }
                            ]

                        }
                        break;
                    default:
                        break;

                }
                if (component.hasComponentCoregistro()) {
                    // component.getComponentCoregistro().replaceWith(component_coregistro);
                } else {
                    component.append(component_coregistro);
                }
            },
            renderComponentAcceptanceTerms(component) {
                // console.log("Render acceptance terms!!");
                this.show();
                let requiredAcceptance = (component.getRequiredAcceptance() == "true" ? true:false);
                if (requiredAcceptance && !component.hasComponentAcceptanceTerms()) {
                    component.append({
                        type: "C-ACCEPTANCE-TERMS",
                    })
                } else if (!requiredAcceptance && component.hasComponentAcceptanceTerms()) {
                    console.log("Enter here")
                    component.getComponentAcceptanceTerms().remove();
                }
            }

        })
    });

    /* BM.add('B-CONTAINER-COREGISTRO', {
        label: `
                <i class="fas fa-ad fa-5x"></i>
                <p class="b-text-label mt-3">CONTAINER COREGISTRO</p>
              `,
        content: { 
          type: 'C-CONTAINER-COREGISTRO',
         },
        // media: '<svg>...</svg>',
    }); */

}
